import React from 'react';
import FormOne from '../contact/FormOne';
import Accordion from 'react-bootstrap/Accordion';
import { FaPhoneAlt } from 'react-icons/fa';
import { MdEmail } from "react-icons/md";
import { FaArrowDown } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { scroller } from 'react-scroll';

function scrollToSection(event) {
    event.preventDefault();  // Prevent default anchor behavior
    scroller.scrollTo('sectionbaixo', {
        smooth: true,
        duration: 500,
        offset: -50,
    });
}

const AboutTwo = () => {
    const { t } = useTranslation();
    
    return (
        <div className="section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="why-choose-us">
                            <div className="section-heading heading-left">
                                <span className="subtitle">{t('Informatique')}</span>
                                <p className="title h3">{t('Tem dúvidas sobre o serviço?')}</p>
                                <p>{t('Envie-nos uma mensagem ou consulte em baixo todos os detalhes do serviço')}</p>
                            </div>
                            <Accordion defaultActiveKey="1">
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header><FaPhoneAlt /> {t('Téléphone')}</Accordion.Header>
                                    <Accordion.Body>
                                        {process.env.REACT_APP_CONTACT_PHONE}
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header><MdEmail /> {t('Email')}</Accordion.Header>
                                    <Accordion.Body>
                                        {process.env.REACT_APP_SUPPORT_EMAIL}
                                    </Accordion.Body>
                                </Accordion.Item>
                                <a
                                    href="#sectionbaixo"
                                    className="h5"
                                    style={{ marginTop: "5%", color: "var(--color-lighter-rose)", cursor: "pointer" }}
                                    onClick={scrollToSection}
                                >
                                    <FaArrowDown /> {t('Ver detalhes')}
                                </a>
                            </Accordion>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-6 offset-xl-1">
                        <div className="contact-form-box shadow-box mb--30">
                            <p className="title h3">{t('Get a free quote now')}</p>
                            <FormOne />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutTwo;